/**
 * @exports onHasMotion
 * @exports hasMotion
 * @exports onHasMouse
 * @exports hasMouse
 * @exports onHasTouch
 * @exports hasTouch
 * @exports onIsDarkMode
 * @exports isDarkMode
 * @exports onIsForcedColors
 * @exports isForcedColors
 * @exports onIsHighContrast
 * @exports isHighContrast
 */

/* -----------------------------------------------------------------------------
 * hasMotion
 * -------------------------------------------------------------------------- */

const hasMotionCallbacks = []
const hasMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)')

hasMotionQuery.addEventListener('change', () => {
    hasMotionCallbacks.forEach(callback => {
        callback(!hasMotionQuery.matches)
    })
})

export function onHasMotion(callback) {
    hasMotionCallbacks.push(callback)
}

export function hasMotion() {
    return !hasMotionQuery.matches
}

/* -----------------------------------------------------------------------------
 * hasMouse
 * -------------------------------------------------------------------------- */

const hasMouseCallbacks = []
const hasMouseQuery = window.matchMedia('screen and (hover: hover) and (pointer: fine)')

hasMouseQuery.addEventListener('change', () => {
    hasMouseCallbacks.forEach(callback => {
        callback(hasMouseQuery.matches)
    })
})

export function onHasMouse(callback) {
    hasMouseCallbacks.push(callback)
}

export function hasMouse() {
    return hasMouseQuery.matches
}

/* -----------------------------------------------------------------------------
 * hasTouch
 * -------------------------------------------------------------------------- */

const hasTouchCallbacks = []
const hasTouchQuery = window.matchMedia('screen and (hover: none) and (any-pointer: none), screen and (hover: none) and (any-pointer: coarse)')

hasTouchQuery.addEventListener('change', () => {
    hasTouchCallbacks.forEach(callback => {
        callback(hasTouchQuery.matches)
    })
})

export function onHasTouch(callback) {
    hasTouchCallbacks.push(callback)
}

export function hasTouch() {
    return hasTouchQuery.matches
}

/* -----------------------------------------------------------------------------
 * isDarkMode
 * -------------------------------------------------------------------------- */

const isDarkModeCallbacks = []
const isDarkModeQuery = window.matchMedia('(prefers-color-scheme: dark)')

isDarkModeQuery.addEventListener('change', () => {
    isDarkModeCallbacks.forEach(callback => {
        callback(isDarkModeQuery.matches)
    })
})

export function onIsDarkMode(callback) {
    isDarkModeCallbacks.push(callback)
}

export function isDarkMode() {
    return isDarkModeQuery.matches
}

/* -----------------------------------------------------------------------------
 * isForcedColors
 * -------------------------------------------------------------------------- */

const isForcedColorsCallbacks = []
const isForcedColorsQuery = window.matchMedia('(forced-colors: active)')

isForcedColorsQuery.addEventListener('change', () => {
    isForcedColorsCallbacks.forEach(callback => {
        callback(isForcedColorsQuery.matches)
    })
})

export function onIsForcedColors(callback) {
    isForcedColorsCallbacks.push(callback)
}

export function isForcedColors() {
    return isForcedColorsQuery.matches
}

/* -----------------------------------------------------------------------------
 * isHighContrast
 * -------------------------------------------------------------------------- */

const isHighContrastCallbacks = []
const isHighContrastQuery = window.matchMedia('(prefers-contrast: more)')

isHighContrastQuery.addEventListener('change', () => {
    isHighContrastCallbacks.forEach(callback => {
        callback(isHighContrastQuery.matches)
    })
})

export function onIsHighContrast(callback) {
    isHighContrastCallbacks.push(callback)
}

export function isHighContrast() {
    return isHighContrastQuery.matches
}

/* -----------------------------------------------------------------------------
 * breakpoint
 * -------------------------------------------------------------------------- */

const breakpointCallbacks = []
const breakpoints = [
    { name: 'xsmall',   query: window.matchMedia('(width <= 480px)') },
    { name: 'small',    query: window.matchMedia('(480px < width <= 768px)') },
    { name: 'medium',   query: window.matchMedia('(768px < width <= 920px)') },
    { name: 'large',    query: window.matchMedia('(920px < width <= 1200px)') },
    { name: 'xlarge',   query: window.matchMedia('(1200px < width <= 1600px)') },
    { name: 'xxlarge',  query: window.matchMedia('(1600px < width)') }
]

breakpoints.forEach(({ query }) => {
    query.addEventListener('change', (event) => {
        if (event.matches) {
            breakpointCallbacks.forEach(callback => {
                callback(breakpoint())
            })
        }
    })
})

export function onBreakpoint(callback) {
    breakpointCallbacks.push(callback)
}

export function breakpoint() {
    let match
    breakpoints.forEach(({ name, query }) => {
        if (query.matches) {
            match = name
        }
    })
    return match
}
